module.exports = __webpack_public_path__ + "static/media/mkt.6004feb6.svg";